const messages = {
    account: {
      yourIdentityKey: 'Identity Key',
      shareToVerify: 'Share this key with others to connect to verify your account.',
      textWriteWords: 'Write down the following 16 words on a piece of paper or somewhere safe you will not loose.',
      recoveryWords: 'Recovery Words',
      yourAccountKey: 'Your Account Key',
      textAccountKey: 'This your raw account key which is generated from your recovery words. You only need this for more technical sharing, like with robots',
      btnShowRecoveryWords: 'Show Recovery Words',
      btnShowActualKey: 'Show Account Key',
      btnTestRecovery: 'Test Recovery',
      btnRestoreAccount: 'Restore Account',
      btnNewShipment: 'New Shipment',
      connected: 'Connected',
    },
    accountTypes: {
      unspecified: 'Unspecified',
      person: 'Person',
      group: 'Group',
      robot: 'Robot',
      company: 'Company',
    },
    auth: {
      myAccount: 'Restore Your Account',
      haveKey: 'If you have used an EOTL account previously and would like to restore your account, enter your account key below.',
      placeholderKey: 'type your sixteen word account key here',
      restoreError: 'Something went wrong restoring your account.',
      btnRestoreKey: 'Restore Key',
      btnRestoreCancel:'Cancel',
    },
    estimate: 'Estimate',
    shipment:{
      title: 'Shipment',
      size: 'Size',
      weight: 'Weight',
      shipmentSpeed: 'Shipment Speed',
    },
    sizes: {
      sm: 'Small',
      md: 'Medium',
      lg: 'Large',
      xl: 'X-Large',
    },
    weights: {
      light: 'Light',
      average: 'Average',
      heavy: 'Heavy',
      very: 'Very Heavy',
      crazy: 'Crazy',
    },
    speeds: {
      immediate: 'Immediately',
      day: 'Same Day',
      next: 'Next Day',
      second: 'Day After Tomorrow',
      week: 'Within Week',
    },
    pickup: {
      title: 'Pickup',
      name: 'Name (optional)',
      contactMethod: 'Method (optional)',
      contact: 'Contact',
      address: 'Adress',
      addressSuffix: 'Adress Suffix',
      city: 'City',
      state:'State',
      postal:'Postal',
    },
    destination: {
      title: 'Destination',
      name: 'Name (optional)',
      contactMethod: 'Method (optional)',
      contact: 'Contact',
      address: 'Adress',
      addressSuffix: 'Adress Suffix',
      city: 'City',
      state:'State',
      postal:'Postal',
    },
    delivery: {
      title: 'Details',
      payment: 'Payment',
      paymentMethod: 'Method',
      paymentPayer: 'Payer',
      tos: 'Terms of Service',
      tosMust: 'You must read our full terms of service before proceeding',
      tosAgree: 'You agree to our terms of service',
      btnCancel: 'Cancel Order',
      btnComplete: 'Complete Order',
    },
    countries: [
        { "value": "at", "text": "Austria" },
        { "value": "be", "text": "Belgium" },
        { "value": "br", "text": "Brazil" },
        { "value": "ca", "text": "Canada" },
        { "value": "cz", "text": "Czech Republic" },
        { "value": "dk", "text": "Denmark" },
        { "value": "fi", "text": "Finland" },
        { "value": "fr", "text": "France" },
        { "value": "de", "text": "Germany" },
        { "value": "is", "text": "Iceland" },
        { "value": "it", "text": "Italy" },
        { "value": "ie", "text": "Ireland" },
        { "value": "ir", "text": "Iran" },
        { "value": "nl", "text": "Netherlands" },
        { "value": "no", "text": "Norway" },
        { "value": "pl", "text": "Poland" },
        { "value": "pt", "text": "Portugal" },
        { "value": "ru", "text": "Russia" },
        { "value": "es", "text": "Spain" },
        { "value": "se", "text": "Sweden" },
        { "value": "ch", "text": "Switzerland" },
        { "value": "tr", "text": "Turkey" },
        { "value": "uk", "text": "United Kingdom" },
        { "value": "us", "text": "United States" }
    ]
}

export default messages;
